import type { Translations } from "../types";

const uk: Translations = {
  "meta.title": "Карта кліків за країнами",
  "meta.description":
    "Інтерактивна карта світу: безкоштовні кліки для кожної країни та платна підтримка через Stripe, PayPal і Buy Me a Coffee.",

  "app.title": "Карта кліків за країнами",

  "map.intro":
    "Натисніть на країну на карті, щоб віддати їй безкоштовний голос, або надішліть фінансову підтримку - обидва способи враховуються в загальному рейтингу нижче. Карта відображає лише підтримку в межах цього застосунку, а не реальне національне багатство чи ВВП.",
  "map.verifying": "Перевірка …",
  "map.confirmNotRobot": "Перш ніж додати безкоштовний клік, підтвердіть, що ви не робот:",
  "map.tryAgain": "Спробувати ще раз",
  "map.registeringClick": "Реєстрація кліку …",
  "map.selectedCountry": "Вибрана країна: {name}.",
  "map.selectFirstFeedback": "Країну вибрано. Щоб додати безкоштовний клік, спочатку підтвердьте нижче, що ви не робот.",
  "map.verificationExpired": "Термін перевірки минув - підтвердьте ще раз, що ви не робот.",
  "map.slowDown": "Трохи повільніше - зачекайте перед наступним кліком.",
  "map.clickFailed": "Не вдалося зареєструвати клік. Спробуйте ще раз.",
  "map.clickErrorGeneric": "Помилка реєстрації кліку.",
  "map.leaderboardHeading": "Рейтинг країн",
  "map.emptySelection": "Виберіть країну на карті, щоб клікнути або підтримати її.",
  "map.loadingData": "Завантаження даних …",

  "worldmap.loadError": "Не вдалося завантажити карту.",
  "worldmap.resetZoom": "Скинути масштаб",
  "worldmap.resetButton": "⤾ Скинути",
  "worldmap.loadingMap": "Завантаження карти …",
  "worldmap.unknownCountry": "Невідомо",
  "worldmap.ariaClicks": "{name}: {clicks} кліків",
  "worldmap.tooltipClicks": "{clicks} кліків",

  "legend.fewer": "Менше кліків",
  "legend.more": "Більше кліків",

  "list.empty": "Кліків ще немає. Будьте першим!",
  "list.ariaLabel": "Рейтинг країн за кількістю кліків",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY не задано - дивіться README щодо налаштування.",
  "human.verificationFailedGeneric": "Перевірку не пройдено.",
  "human.networkError":
    "Не вдалося з'єднатися з сервісом перевірки (помилка мережі) - перевірте VITE_SUPABASE_URL, чи розгорнуто функцію verify-human, та ALLOWED_ORIGIN; дивіться README/NAVODILA.",
  "human.verificationFailedRetry": "Перевірку не пройдено, спробуйте ще раз.",

  "provider.stripe": "💳 Картка (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Вибрана країна",
  "panel.currentlyRanked": "Наразі на #{rank} місці",
  "panel.shareCopied": "Скопійовано ✓",
  "panel.shareShared": "Поширено ✓",
  "panel.shareButton": "🔗 Поширити",

  "panel.tableClicks": "Кліки",
  "panel.tableFree": "Безкоштовні",
  "panel.tablePaid": "Платні",
  "panel.rowAllTime": "За весь час",
  "panel.rowThisYear": "Цього року",
  "panel.rowThisWeek": "Цього тижня",
  "panel.rowToday": "Сьогодні",

  "panel.totalCombined": "Загалом:",
  "panel.totalSupport": "Загальна підтримка:",

  "panel.paymentMethod": "Спосіб оплати",
  "panel.noPaymentMethod": "Наразі немає доступного способу оплати.",
  "panel.supportAmount": "Сума підтримки (EUR)",
  "panel.amountRange": "Сума має бути в межах від {min} до {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Орієнтовна кількість платних кліків:",
  "panel.ratioInfo":
    "Співвідношення: {a} = {b} кліків (наприклад, {c} = {d} кліків). Це лише орієнтовна оцінка до оплати - остаточну кількість кліків завжди обчислює й підтверджує сервер на основі фактично підтвердженого платежу.",
  "panel.preparing": "Підготовка …",
  "panel.continueWith": "Продовжити з {provider}",
  "panel.choosePaymentMethod": "Виберіть спосіб оплати",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME не задано - дивіться README щодо налаштування.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID не задано - дивіться README щодо налаштування.",

  "panel.paypalAmountInfo": "Сума: {amount} (орієнтовно {clicks} кліків). Завершіть оплату за допомогою кнопки PayPal нижче.",
  "panel.back": "← Назад",

  "panel.bmcWarningTitle": "⚠️ Перш ніж перейти до BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Вставте наведений нижче код у поле повідомлення/примітки під час оформлення — лише так ми дізнаємося, яку країну ви підтримуєте. Без коду ми не зможемо прив'язати платіж до жодної країни.",
  "panel.copy": "Копіювати",
  "panel.copied": "Скопійовано ✓",
  "panel.suggestedAmount": "Рекомендована сума:",
  "panel.bmcAmountNote":
    "(орієнтовно {clicks} кліків). BuyMeCoffee, на жаль, не підтримує передавання суми через посилання — введіть/виберіть її самостійно на їхньому сайті. Фактична кількість кліків завжди обчислюється на основі суми, яку ви дійсно надіслали через BuyMeCoffee, а не на основі цієї оцінки.",
  "panel.openBmc": "Відкрити BuyMeCoffee і продовжити →",
  "panel.waitingProvider": "Очікування підтвердження оплати від платіжного провайдера …",
  "panel.waitingConfirmation": "Очікування підтвердження оплати …",
  "panel.timedOut":
    "Час очікування вичерпано. Якщо оплату здійснено, карта оновиться після отримання підтвердження сервером - іноді це може зайняти трохи більше часу.",
  "panel.checkAgain": "Перевірити ще раз",

  "panel.cancelled": "Оплату скасовано або вона не пройшла. Карта не змінилася.",
  "panel.tryAgain": "Спробувати ще раз",

  "panel.confirmed": "✅ Підтримку підтверджено!",
  "panel.confirmedBody": "{country} отримала {clicks} платних кліків на суму {amount}.",

  "panel.errorPreparingSupport": "Помилка під час підготовки підтримки.",
  "panel.errorPreparingPayment": "Помилка під час підготовки оплати.",
  "panel.errorConfirmingPayment": "Помилка під час підтвердження оплати.",
  "panel.errorPayingPaypal": "Помилка оплати через PayPal.",

  "share.unranked": "{flag}{country} потребує вашої підтримки на карті світу!\nДопоможіть їй піднятися в рейтингу 👇",
  "share.rank1": "{flag}{country} наразі на 1 місці!\nДопоможіть нам залишитися лідером 👇",
  "share.rankN": "{flag}{country} наразі на #{rank} місці!\nДопоможіть нам дістатися #1 👇",

  "language.switcherLabel": "Мова",
};

export default uk;
